export {NetworkStatus, isNetworkRequestSettled, gql} from "@apollo/client"
